import {
  MasonryWSDriverNodeRenderersRegistry,
  MasonryDriverNodeRenderersRegistry,
  MasonryDriverActionController,
} from '@leagueplatform/masonry';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
  MASONRY_ACTION_TYPES,
} from 'common/constants/masonry';
import { NotificationCardRenderer } from 'components/notifications/renderers/notification-card.renderer';
import { NotificationDetailsRenderer } from 'components/notifications/renderers/notification-details.renderer';
import { NotificationStackRenderer } from 'components/notifications/renderers/notification-stack.renderer';

export const initNotificationsRegistry = () => {
  // LIST PAGE
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_NAMESPACES.NOTIFICATIONS,
    MASONRY_WIDGET_TYPES.NOTIFICATION_CARD,
    NotificationCardRenderer,
  );

  MasonryDriverActionController.registerHandler(
    MASONRY_ACTION_TYPES.DEEPLINK,
    MASONRY_NAMESPACES.NOTIFICATIONS,
    () => {},
  );

  // DETAILS PAGE
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_NAMESPACES.NOTIFICATION_DETAILS,
    MASONRY_WIDGET_TYPES.NOTIFICATION_DETAILS_CARD,
    NotificationDetailsRenderer,
  );

  // HOME PAGE & GET CARE PAGE WIDGET
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_NAMESPACES.OVATIENT,
    MASONRY_WIDGET_TYPES.MYCHART_NOTIFICATIONS,
    NotificationStackRenderer,
  );
};
